import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { PlantIdRequest, RmZonesDropDownResponseModel, RmZonesResponseModel } from '@gtpl/shared-models/masters';
import { PlantRequest } from './dto/plant.request';
import { RmZonesService } from './rm-zones.service';
import { RmZonesDTO } from './dto/rm-zone.dto';
@ApiTags('Rm Zones')
@Controller('rm-zones')
export class RmZonesController {
    constructor(
        private RmzonesService: RmZonesService,
        private readonly applicationExceptionhandler: ApplicationExceptionHandler,

      ){}
      /**
       * create or update Zone
       * @param RmzonesDTO 
       * @param isUpdate 
       * @param request 
       */
    @Post('/createZone')
    async createZone(@Body() RmzonesDTO:RmZonesDTO,isUpdate:boolean=false,@Req() request:Request): Promise<RmZonesResponseModel> {
        try {
            // console.log(RmzonesDTO);
            return await this.RmzonesService.createZone(RmzonesDTO, false,request);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(RmZonesResponseModel, error)
        }
    }
    /**
     * create or update Zone
     * @param RmzonesDTO 
     * @param request 
     */
    @Post('/updateZone')
    async updateZone(@Body() RmzonesDTO: RmZonesDTO,@Req() request:Request): Promise<RmZonesResponseModel> {
        try {
            return await this.RmzonesService.createZone(RmzonesDTO, true,request);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(RmZonesResponseModel, error)
        }
    }
    /**
     * get All Zones
     * @param request 
     */
     @Post('/getAllZoneDropDown')
     async getAllZoneDropDown(): Promise<RmZonesDropDownResponseModel> {
         try {
          return await this.RmzonesService.getAllZoneDropDown();
        } catch (error) {
             return this.applicationExceptionhandler.returnException(RmZonesDropDownResponseModel, error);
        }
      }

      @Post('getPlantWiseZones')
        async getPlantWiseZones(@Body() req: PlantIdRequest):Promise<RmZonesDropDownResponseModel>{
            console.log(req);
        try {
            return await this.RmzonesService.getPlantWiseZones(req);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(RmZonesDropDownResponseModel, error);
        }
    }
}
